/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { THEME_CONFIG } from '@/config/themeConfig';

/**
 * ColorField — native color picker + HEX text input.
 */
export const ColorField = ({ label, value, onChange, testId }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <div className="flex items-center gap-2 mt-1">
      <input
        type="color"
        value={value || THEME_CONFIG.colors.primary}
        onChange={(e) => onChange(e.target.value)}
        className="h-10 w-14 rounded border cursor-pointer bg-background"
        data-testid={`${testId}-picker`}
      />
      <Input value={value || ''} onChange={(e) => onChange(e.target.value)} className="font-mono text-xs" data-testid={`${testId}-hex`} />
    </div>
  </div>
);

/**
 * BrandColorsCard — primary / secondary / accent color editors with gradient preview.
 * Extracted from BrandSettingsPage.jsx (Code Quality refactor).
 */
export const BrandColorsCard = ({ settings, patch }) => (
  <Card>
    <CardHeader><CardTitle className="text-base">Colori</CardTitle></CardHeader>
    <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <ColorField label="Colore primario" value={settings.primaryColor} onChange={(v) => patch({ primaryColor: v })} testId="brand-primary" />
      <ColorField label="Colore secondario" value={settings.primaryColorAlt} onChange={(v) => patch({ primaryColorAlt: v })} testId="brand-primary-alt" />
      <ColorField label="Colore accento" value={settings.accentColor} onChange={(v) => patch({ accentColor: v })} testId="brand-accent" />
      <div
        className="md:col-span-3 p-4 rounded-lg border"
        style={{ background: `linear-gradient(135deg, ${settings.primaryColor} 0%, ${settings.primaryColorAlt} 100%)`, color: '#fff' }}
        data-testid="brand-preview"
      >
        <div className="font-bold">Anteprima gradient primario</div>
        <div className="text-xs opacity-80">Usato per pulsanti principali, logo e header</div>
      </div>
    </CardContent>
  </Card>
);
